import { Link } from "react-router-dom";
import { sizeFor } from "../../data/imageSize";
import { useReveal } from "../../hooks/useReveal";

const homepageTestimonials = [
  {
    name: "Roxanne L. (Huntington Beach, CA)",
    quote:
      "Jessica Has Been A Wonderful Medicare Specialist. I was Highly Recommended To her From My Children's Father. She Has Given me Great Help with My Medicare Plan. I Would Highly Recommend Her To Friends And Family. She will Always go out of her Way to help you out. I enjoy working with Her.",
    image: "/roxanne.webp",
  },
  {
    name: "Dr. Siamak Rouzroch, MD (Long Beach, CA)",
    quote:
      "I have been working with Jessica over several years. She is very dedicated to her work and has helped many of my patients to choose the great insurance plans. I highly recommend her!",
    image: "/siamak.webp",
  },
  {
    name: "Lois K. (Phoenix, AZ)",
    quote:
      "You can depend on receiving expert advice and honesty in their service. They will not let you down.",
    image: "/lois.webp",
  },
];

export const AboutUsSection = ({ title, description }) => {
  const testimonialsRef = useReveal();

  return (
    <section
      className="animate-fade-in"
      style={{
        padding: "50px 16px 72px",
        overflow: "visible",
        backgroundColor: "#edf2f7",
        textAlign: "center",
        letterSpacing: "3px",
      }}
    >
      <h2
        style={{
          fontSize: "3rem",
          fontWeight: "normal",
          fontFamily: '"Playfair Display", Georgia, serif',
        }}
      >
        {title}
      </h2>
      <hr className="section-divider" />
      {description ? (
        <p style={{ fontSize: "1rem", color: "#4a5568" }}>{description}</p>
      ) : null}
      <div className="home-testimonials" ref={testimonialsRef}>
        {homepageTestimonials.map((item) => (
          <article key={item.name} className="home-testimonial-card">
            <img
              src={item.image}
              alt={item.name}
              {...sizeFor(item.image)}
              className="home-testimonial-card__photo"
            />
            <h3 className="home-testimonial-card__name">{item.name}</h3>
            <p className="home-testimonial-card__quote">
              &ldquo;{item.quote}&rdquo;
            </p>
          </article>
        ))}
      </div>
      <Link to="/testimonials" className="home-testimonials__link">
        View All Testimonials
        <span className="home-testimonials__arrow" aria-hidden="true">
          →
        </span>
      </Link>
    </section>
  );
};
